import React from "react";
import { USER_STATE_DICTIONARY } from "consts";
//
import { AutoSuggest } from "containers/components/autoSuggest";

const TaskStateAutoSuggest = (props) => {
    const suggestState = (q) => {
        if (q) {
            q = q.toLocaleLowerCase();
        } else {
            q = "";
        }

        return Promise.resolve(
            Object
                .keys(USER_STATE_DICTIONARY)
                .filter(accessKey => (USER_STATE_DICTIONARY[accessKey] || "")
                    .toLocaleLowerCase()
                    .includes(q)
                )
        );
    }

    return (
        <AutoSuggest
            label="State"
            fetchOptions={suggestState}
            renderOption={(state) => ({
                value: state,
                label: USER_STATE_DICTIONARY[state]
            })}
            optionIdentifier={(value) => value}
            {...props}
        />
    );
}

export default TaskStateAutoSuggest;
